export default __webpack_public_path__ + "static/media/descXmas.fa8e91f7.png";